import { selectPeriodoFiscalSelected, updatePeriodoFiscalSelected } from 'store/auth';
import store from 'store/store';
import { logger } from 'utils/debug';

export default (io) => {
  if (io) {
    io.on('connect', () => logger('sockets connected'));
    io.on('connect_error', (error) => logger('[sockets connect_error]', error));
    io.on('disconnect', (reason) => {
      logger(`sockets disconnected, reason: ${reason}`);
      if (reason === 'io server disconnect') {
      // the disconnection was initiated by the server, you need to reconnect manually
        io.connect();
      }
    // else the socket will automatically try to reconnect
    });
    io.on('periodo_fiscal_vigente', ({ current }) => {
      if (current) {
        const periodoFiscalSelected = selectPeriodoFiscalSelected(store.getState());
        if (current?.id === periodoFiscalSelected?.id) {
          store.dispatch(updatePeriodoFiscalSelected(current));
        } else if (periodoFiscalSelected?.vigente) {
          store.dispatch(updatePeriodoFiscalSelected({
            ...periodoFiscalSelected,
            vigente: false,
          }));
        }
      }
    });
  }
};
